<template>
  <v-col
    v-if="showInTab(field)"
    :cols="gridColumns(field)"
    :class="classes"
  >
    <template v-if="(field.info.readOnlyWhenCreated && !value._id) || field.info.readOnly || field.info.type === 'Virtual' || field.info.type === 'SavedVirtual'">
      <template v-if="field.info.type === 'Date'">
        {{ labelText }}:  {{ showDate(value[field.fieldName]) }}
      </template>
      <template v-else-if="field.info.type === 'Datetime'">
        {{ labelText }}: {{ showDatetime(value[field.fieldName]) }}
      </template>
      <div v-else class="cut-long-text">
        {{ labelText }}: {{ value[field.fieldName] }}
      </div>
    </template>

    <!-- STRING -->

    <form-input
      v-else-if="field.info.type === 'String'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :save-callback="saveFormData"
      :module-name="moduleName"
    />

    <!-- IMAGE -->

    <form-image
      v-else-if="field.info.type === 'Image'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :module-name="moduleName"
    />

    <!-- PRIVATE FILE -->

    <form-private-file
      v-else-if="field.info.type === 'PrivateFile'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :module-name="moduleName"
    />

    <!-- FILE -->

    <form-file
      v-else-if="field.info.type === 'File'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :module-name="moduleName"
    />

    <!-- RICHTEXT -->

    <form-richtext
      v-else-if="field.info.type === 'Richtext'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :module-name="moduleName"
    />

    <!-- RICHTEXT -->

    <form-richtext
      v-else-if="field.info.type === 'HtmlCode'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :module-name="moduleName"
    />

    <!-- DATE -->

    <form-date
      v-else-if="field.info.type === 'Date'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :module-name="moduleName"
    />

    <!-- DATETIME -->

    <form-date-time
      v-else-if="field.info.type === 'Datetime'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :module-name="moduleName"
    />

    <!-- NUMBER -->

    <form-number
      v-else-if="field.info.type === 'Number'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :module-name="moduleName"
    />

    <!-- BOOLEAN -->
    <form-boolean
      v-else-if="field.info.type === 'Boolean'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :module-name="moduleName"
    />


    <!-- OBJECT STATE -->

    <FormObjectState
      v-else-if="field.fieldName === 'state' && field.info.type === 'Link' &&
      field.canRead &&
      showInForm(field, field.fieldName)"
      v-model="value[field.fieldName]"
      :field="field"
      :label-text="labelText"
      :id="id"
      :module-name="moduleName"
      :change-state-for-field="changeStateForField"
    />



    <!-- LINK -->

    <v-autocomplete
      v-else-if="field.info.type === 'Link' &&
        field.canRead &&
        showInForm(field, field.fieldName)"
      v-model="value[field.fieldName]"
      :items="linkOptionsComputed"
      :label_x="field.info.linkOptionsFilterField"
      :label="labelText"
      :disabled="!field.canEdit || isParentReferenceField(field.fieldName)"
      item-text="text"
      item-value="value"

      :rounded="cs.inputRounded"
      :dense="cs.inputDense"
      :outlined="cs.inputOutlined"
      :filled="cs.inputFilled"
      :background-color="fieldBackgroundColor(value[field.fieldName], field)"
      :append-outer-icon="value[field.fieldName] ? 'fa-external-link-alt' : null"
      :search-input.sync="searchInput"
      @click:append-outer="openReferenceLink(field, value[field.fieldName])"

      clearable
      hide-details
    ></v-autocomplete>

    <!-- MULTILINK -->

    <form-multi-link
      v-else-if="field.info.type === 'MultiLink'"
      v-model="value"
      :field="field"
      :label-text="labelText"
      :link-options="linkOptions"
      :module-name="moduleName"
    />

    <!-- TITLE -->

    <h2 v-else-if="field.info.type === 'Title' && field.canRead">
      {{ labelText }}
    </h2>

    <!-- DENORMALIZED CHILD -->

    <denormalized-children
      v-else-if="field.info.type === 'Denormalized'"
      v-model="value[field.fieldName]"
      :label-text="labelText"
      :field="field"
    />

    <!-- FEATURES BY GROUP -->

    <features-by-group
      v-else-if="field.info.type === 'FeaturesByGroup'"
      v-model="value[field.fieldName]"
      :label="labelText"
      :parent-module-name="moduleName"
      :parent-id="id"
      :feature-group-ids="field.info.featureGroupIds"
    />

    <!-- FEATURES FROM GROUP -->

    <template v-else-if="field.info.type === 'Features'">
      <h3>{{ labelText }}</h3>
      <v-divider />
      <features-from-group
        v-model="value[field.fieldName]"
        :parent-module-name="moduleName"
        :feature-group-ids="[fieldConfig.featureGroupId]"
      />
    </template>

    <!-- SUBTABLE -->

    <form-subtable
      v-else-if="field.info.type === 'Subtable'"
      v-model="value"
      :field="field"
      :parent-id="id"
      :label-text="labelText"
      :module-name="moduleName"
      :level="level"
      :set-subtable-form-open-module="setSubtableFormOpenModule"
    />

  </v-col>
</template>

<script>
import FormObjectState from './FormElements/FormObjectState'
import FormMultiLink from './FormElements/FormMultiLink'
import FormBoolean from './FormElements/FormBoolean'
import FormInput from './FormElements/FormInput'
import FormImage from './FormElements/FormImage'
import FormPrivateFile from './FormElements/FormPrivateFile'
import FormFile from './FormElements/FormFile'
import FormRichtext from './FormElements/FormRichtext'
import FormNumber from './FormElements/FormNumber'
import FormDate from './FormElements/FormDate'
import FormDateTime from './FormElements/FormDateTime'
import FormSubtable from './FormElements/FormSubtable'
import sharedComputed from './../computed'
import sharedMethods from './../methods'
import FeaturesByGroup from './FeaturesByGroup'
import FeaturesFromGroup from './FeaturesFromGroup'
import DenormalizedChildren from './DenormalizedChildren'

export default {
  name: 'ModuleFormField',

  components: {
    FormObjectState,
    DenormalizedChildren,
    FeaturesByGroup,
    FeaturesFromGroup,
    FormInput,
    FormNumber,
    FormRichtext,
    FormSubtable,
    FormPrivateFile,
    FormImage,
    FormFile,
    FormDate,
    FormBoolean,
    FormDateTime,
    FormMultiLink
  },

  data () {
    return {
      searchInput: null,
      linkOptionsBySearch: [],
      searchTimer: null
    }
  },

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    field: {
      type: Object,
      default: () => {
        return {}
      }
    },
    linkOptions: {
      type: Object,
      default: () => {
        return {}
      }
    },
    moduleName: {
      type: String,
      default: null
    },

    parentModule: {
      type: String,
      default: null
    },

    parentId: {
      type: String,
      default: null
    },

    id: {
      type: String,
      default: null
    },

    tab: {
      type: String,
      default: null
    },

    subtableFormOpenForModule: {
      type: String,
      default: null
    },

    setSubtableFormOpenModule: {
      type: Function,
      default: () => {}
    },

    level: {
      type: Number,
      default: 0
    },

    saveFormData: {
      type: Function,
      default: () => {}
    },

    displayNone: {
      type: Boolean,
      default: false
    }
  },

  created () {
    // Get link options filtered by another field
    if (this.linkOptionsFilterField) {
      this.searchLinkOptionsBySearchInput()
    }
  },

  computed: {
    ...sharedComputed,

    linkOptionsFilterField () {
      return this.modules[this.moduleName].fields[this.field.fieldName].linkOptionsFilterField
    },

    linkOptionsComputed () {
      const linkModuleDisplayField = this.modules[this.moduleName].fields[this.field.fieldName].linkModuleDisplayField
      if ((this.searchInput && this.linkOptionsBySearch.length > 0) || this.linkOptionsFilterField) {
        return this.linkOptionsBySearch.map((option) => {
          return {
            text: option[linkModuleDisplayField + '_' + this.language] ||
              option[linkModuleDisplayField + '_en'] ||
              option[linkModuleDisplayField],
            value: option._id,
            info: option
          }
        })
      }
      console.log('value now...', this.value[this.field.fieldName + 'Populated'], this.linkOptions[this.field.fieldName])
      // If current value is not in select options, add it
      const selectedPopulatedValue = this.value[this.field.fieldName + 'Populated']
      const optionsIncludesSelectedValue = selectedPopulatedValue &&
        this.linkOptions[this.field.fieldName].map(option => option.value).includes(selectedPopulatedValue.id)
      if (!optionsIncludesSelectedValue && selectedPopulatedValue) {
        const selectedValueForDropdown = {
          text: selectedPopulatedValue[linkModuleDisplayField + '_' + this.language] ||
              selectedPopulatedValue[linkModuleDisplayField + '_en'] ||
              selectedPopulatedValue[linkModuleDisplayField],
          value: selectedPopulatedValue.id,
          info: selectedPopulatedValue
        }
        return [selectedValueForDropdown]
      }
      return this.linkOptions[this.field.fieldName]
    },

    classes () {
      let classes = ['elevation-0']
      if (this.displayNone) {
        classes.push('d-none')
      }
      if (this.field.info.type === 'Subtable') {
        classes.push('pa-0')
      }
      if (this.subtableFormOpenForModule === this.field.fieldName) {
        classes.push('pa-0')
      }
      return classes
    },

    fieldConfig () {
      let config = {}
      if (!this.field || !this.field.info || !this.field.info.config) {
        return config
      }
      try {
        config = JSON.parse(this.field.info.config)
      } catch (e) {
        console.log('broken config for ', this.field, e)
      }
      return config
    },

    labelText () {
      return this.field.info['fieldNameText_' + this.language] || this.field.info.fieldNameText_en || this.field.info.fieldName
    },

    allLinkOptionsDownloaded () {
      let options = this.linkItems && this.linkItems[this.field.info.linkModule]
      let optionsCount = this.linkItemsCount && this.linkItemsCount[this.field.info.linkModule]
      const allOptionsDownloaded = options && options.length === optionsCount
      return allOptionsDownloaded
    }
  },

  watch: {
    searchInput (searchInput) {
      if (!searchInput && this.linkModuleDisplayField) {
        this.linkOptionsBySearch = []
        return false
      }
      if (!this.allLinkOptionsDownloaded) {
        clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(() => {
          this.searchLinkOptionsBySearchInput(searchInput)
        }, 300)
      }
    }
  },

  methods: {
    ...sharedMethods,

    searchLinkOptionsBySearchInput (searchInput) {
      this.$store.dispatch('getLinkFieldListItems', {
        moduleName: this.field.info.linkModule,
        linkModuleDisplayField: this.field.info.linkModuleDisplayField,
        searchInput: searchInput,
        linkOptionsFilterField: this.linkOptionsFilterField,
        linkOptionsFilterFieldValue: this.value[this.linkOptionsFilterField]

      }).then(result => {
        this.linkOptionsBySearch = result.items
      })
    },

    openReferenceLink (field, value) {
      if (value && field && field.info && field.info.linkModule) {
        window.open('/#/' + field.info.linkModule + '/form/' + value, '_blank')
      }
    },

    changeStateForField (field, objectState) {
      this.value[field.fieldName] = objectState.id
    },

    showInTab (field) {
      let tabValid = false
      if (!this.tab && !field.info.tab) {
        tabValid = true
      } else if (this.tab === field.info.tab) {
        tabValid = true
      }
      return tabValid && this.passesFieldDisplayRules(field)
    },

    passesFieldDisplayRules (field) {
      if (field.fieldName === 'createdAt' && this.id === '0') { return false }
      let displayRules = this.modules[this.moduleName].fields[field.fieldName].displayRules
      if (!displayRules || Object.keys(displayRules).length === 0) { return true }
      // Currently supporting AND conditions
      let conditionsPassed = true
      Object.keys(displayRules).forEach(conditionField => {
        displayRules[conditionField].forEach(displayRule => {
          if (displayRule.mustHave) {
            if (!displayRule.mustHaveValue) { displayRule.mustHaveValue = null }
            if (this.value[conditionField] !== displayRule.mustHaveValue) {
              conditionsPassed = false
            }
          }
          if (displayRule.mustNotHave) {
            if (!displayRule.mustNotHaveValue) { displayRule.mustNotHaveValue = null }
            if (this.value[conditionField] === displayRule.mustNotHaveValue) {
              conditionsPassed = false
            }
          }
        })
      })
      return conditionsPassed
    },

    saveCallback () {
      this.saveFormData()
    },

    isParentReferenceField (fieldName) {
      if (!this.parentId || !this.parentModule) { return false }
      return this.modules[this.parentModule].singular === fieldName || fieldName === 'referenceModule'
    },

    showInForm (field, fieldName) {
      let hideSubtableReferenceField = false
      if (this.parentId) {
        let singularParentObjectName = this.modules[this.parentModule].singular
        if (singularParentObjectName === fieldName) {
          // hideSubtableReferenceField = true // Instead disable
        }
      }
      return !hideSubtableReferenceField
    }
  }
}
</script>

<style>
.v-input__append-outer .v-input__icon--append-outer .v-icon.v-icon {
  font-size: 14px;
}
</style>
